import * as React from 'react';
import { Box } from "./..";
import { _getInputStyles } from "./TextInput.styles";
var TextInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
  var onChangeHandler = React.useCallback(function (event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(Box, {
    as: "input",
    ref: ref,
    type: type,
    value: value,
    placeholder: placeholder,
    onChange: onChangeHandler,
    autoFocus: autoFocus,
    onFocus: onFocus,
    onBlur: onBlur,
    sx: _getInputStyles({
      size: size,
      disabled: disabled
    })
  });
});
export default TextInput;